import { cn } from "@/lib/utils";

const TONES = {
  success: "bg-success",
  warning: "bg-warning",
  danger: "bg-destructive",
  info: "bg-info",
  vacation: "bg-status-vacation",
  sick: "bg-status-sick",
  muted: "bg-muted-foreground/40",
  brand: "bg-primary",
} as const;

export type Tone = keyof typeof TONES;

/** Status als Punkt + Text (nie nur Farbe). */
export function StatusDot({ tone, label, className }: { tone: Tone; label: string; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-[13px]", className)}>
      <span className={cn("size-2 shrink-0 rounded-full", TONES[tone])} />
      {label}
    </span>
  );
}

const SOFT = {
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-destructive-soft text-destructive",
  info: "bg-info-soft text-info",
  vacation: "bg-status-vacation-soft text-status-vacation",
  sick: "bg-status-sick-soft text-status-sick",
  muted: "bg-muted text-muted-foreground",
  brand: "bg-brand-soft text-brand-ink",
} as const;

export function Pill({ tone, children, className }: { tone: Tone; children: React.ReactNode; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap", SOFT[tone], className)}>
      {children}
    </span>
  );
}
